import { lighten, darken } from '@material-ui/core/styles/colorManipulator';
import * as colors from '../common/colors';

export default {
  common: {
    black: colors.black,
    white: colors.white,
    neutral: colors.grey[200],
    muted: colors.grey[300],
  },
  grey: { ...colors.grey },
  primary: {
    contrastText: colors.white,
    main: '#454DCC',
    light: lighten('#454DCC', 0.35),
    dark: darken('#454DCC', 0.2),
  },
  error: {
    contrastText: colors.white,
    main: colors.red,
    light: lighten(colors.red, 0.3),
    dark: darken(colors.red, 0.15),
  },
  secondary: {
    contrastText: colors.white,
    main: '#2AA5EA',
    light: lighten('#2AA5EA', 0.3),
    dark: darken('#2AA5EA', 0.15),
  },
  success: {
    contrastText: colors.white,
    main: colors.green,
    light: lighten(colors.green, 0.3),
    dark: darken(colors.green, 0.15),
  },
  info: {
    contrastText: colors.white,
    main: colors.blue,
    light: lighten(colors.blue, 0.3),
    dark: darken(colors.blue, 0.15),
  },
  warning: {
    contrastText: colors.white,
    main: colors.orange,
    light: lighten(colors.orange, 0.35),
    dark: darken(colors.orange, 0.1),
  },
  danger: {
    contrastText: colors.white,
    main: colors.red,
    light: lighten(colors.red, 0.3),
    dark: darken(colors.red, 0.15),
  },
  text: {
    primary: '#12161B',
    secondary: colors.grey[600],
    contrast: colors.white,
    disabled: colors.grey[300],
  },
  background: {
    default: colors.grey[200],
    inverted: colors.grey[800],
    paper: colors.white,
  },
  border: colors.grey[300],
  divider: colors.grey[300],
};
